import "./AlertComponent.scss";

import React from "react";

import { Grid2 } from "@mui/material";
import Alert, { AlertColor } from "@mui/material/Alert";
import ButtonMui from "@mui/material/Button";

import { Button } from "../../models/app-data-model";
import RichTextBlock from "../rich-text-block/RichTextBlock";

export type AlertComponentProps = {
  message: string;
  severityLevel: AlertColor;
  button: Button;
};

export type buttonVariant = 'text' | 'contained' | 'outlined';

const AlertComponent: React.FC<AlertComponentProps> = ({ severityLevel, message, button }) => {
  const buttonUrl =  button.reference || button.link ? (button.link && button.link[0]?.href)  || (button.reference && button.reference[0]?.url) : null;
  const sevierityLevelData = severityLevel?.toLowerCase() as AlertColor;
  const buttonVariant = button && button.button_type?.toLowerCase() as buttonVariant;

  return (
    <Grid2 className="page-alert">
      <Alert className="alert-component" severity={sevierityLevelData} role='alert'>
        <Grid2 container className='alert-content'>
          <Grid2 className="alert-content-rtf">
            <RichTextBlock content={message} />
          </Grid2>
          { buttonUrl && <Grid2 className="alert-content-action"><ButtonMui size="medium" variant={buttonVariant} href={buttonUrl}>{button.label}</ButtonMui></Grid2>}
        </Grid2>
      </Alert>
    </Grid2>
  );
};

export default AlertComponent;
